import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _class2, _descriptor, _class3, _class4, _descriptor2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import truncate from 'lodash/truncate';
import { Dropdown } from '../../../components/Dropdown';
import { task } from 'mobx-task';
import ContentLoading from '../../../components/ContentLoading';
import { observable, computed, action } from 'mobx';
import { observer } from 'mobx-react';
import Icon from '../../../components/Icon';
import InfiniteScrollZone from '../../../components/InfiniteScrollZone';
import DocumentTagsStrip from 'DocumentTagsStrip';
import styles from './DocumentPicker.m.sass';
var DocumentPicker = observer(_class3 = (_class4 = /*#__PURE__*/function (_React$Component2) {
  function DocumentPicker() {
    var _this3;
    _classCallCheck(this, DocumentPicker);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this3 = _callSuper(this, DocumentPicker, [].concat(args));
    _initializerDefineProperty(_this3, "isOpen", _descriptor2, _this3);
    _this3.toggle = action(function () {
      _this3.isOpen = !_this3.isOpen;
      if (_this3.isOpen) {
        return _this3.fetchDocs();
      }
    });
    _this3.fetchDocs = task(function () {
      return _this3.props.scrollProvider.fetch();
    });
    _this3.close = action(function () {
      _this3.isOpen = false;
    });
    _this3.onButtonClick = function () {
      return _this3.toggle();
    };
    return _this3;
  }
  _inherits(DocumentPicker, _React$Component2);
  return _createClass(DocumentPicker, [{
    key: "render",
    value: function render() {
      var _this4 = this;
      var props = this.props;
      return /*#__PURE__*/React.createElement(Dropdown, {
        position: props.position || 'left',
        centerDropdown: true,
        button: props.button,
        isOpen: this.isOpen,
        onButtonClick: this.onButtonClick
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.dropdownInner
      }, /*#__PURE__*/React.createElement(InnerDocumentPicker, {
        userId: this.props.userId,
        documentStore: props.documentStore,
        onClose: function onClose() {
          return _this4.close();
        },
        getDocuments: props.getDocuments,
        filter: props.filter,
        closeOnSelect: props.closeOnSelect,
        onDocumentSelect: props.onDocumentSelect,
        disabled: props.disabled,
        scrollProvider: props.scrollProvider,
        loading: this.fetchDocs.pending,
        emptyText: props.emptyText,
        searchPlaceholder: props.searchPlaceholder,
        hideTags: props.hideTags
      })));
    }
  }]);
}(React.Component), _descriptor2 = _applyDecoratedDescriptor(_class4.prototype, "isOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _class4)) || _class3;
export { DocumentPicker as default };
var InnerDocumentPicker = observer(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  function InnerDocumentPicker() {
    var _this;
    _classCallCheck(this, InnerDocumentPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, InnerDocumentPicker, [].concat(args));
    _initializerDefineProperty(_this, "searchText", _descriptor, _this);
    _this.onSearchChange = action(function (e) {
      _this.searchText = e.target.value;
    });
    _this.selectDocument = function (doc) {
      if (_this.props.onDocumentSelect) {
        _this.props.onDocumentSelect(doc);
      }
      if (_this.props.closeOnSelect !== false) {
        _this.props.onClose();
      }
    };
    return _this;
  }
  _inherits(InnerDocumentPicker, _React$Component);
  return _createClass(InnerDocumentPicker, [{
    key: "documents",
    get: function get() {
      var docs = (this.props.getDocuments ? this.props.getDocuments() : this.props.documentStore.forUser(this.props.userId)).filter(function (d) {
        return !d.archived;
      });
      if (this.props.filter) {
        docs = docs.filter(this.props.filter);
      }
      if (this.searchText) {
        var fields = ['title', 'description'];
        var searchUpper = this.searchText.toUpperCase();
        docs = docs.filter(function (d) {
          return fields.some(function (f) {
            return (d[f] || '').toUpperCase().indexOf(searchUpper) > -1;
          });
        });
      }
      return docs;
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty() {
      if (this.searchText) {
        return /*#__PURE__*/React.createElement(NoDocs, null, "No documents match your search.");
      }
      return /*#__PURE__*/React.createElement(NoDocs, null, this.props.emptyText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        scrollProvider = _this$props.scrollProvider,
        onClose = _this$props.onClose,
        hideTags = _this$props.hideTags,
        disabled = _this$props.disabled;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.root
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.searchField
      }, /*#__PURE__*/React.createElement("input", {
        className: styles.searchFieldInput,
        type: "search",
        placeholder: this.props.searchPlaceholder || 'Search for documents...',
        onChange: this.onSearchChange
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.headerActions
      }, /*#__PURE__*/React.createElement(Icon, {
        onClick: onClose,
        className: styles.headerAction,
        material: true,
        name: "close",
        "data-test": "document-picker-close"
      }))), scrollProvider.fetch.pending ? /*#__PURE__*/React.createElement(ContentLoading, {
        small: true
      }) : /*#__PURE__*/React.createElement("div", {
        className: styles.list
      }, this.documents.length === 0 ? this.renderEmpty() : this.documents.map(function (doc) {
        return /*#__PURE__*/React.createElement(DocumentItem, {
          disabled: disabled,
          document: doc,
          key: doc.id,
          hideTags: hideTags,
          onClick: function onClick() {
            return _this2.selectDocument(doc);
          }
        });
      }), scrollProvider && /*#__PURE__*/React.createElement(InfiniteScrollZone, {
        scrollProvider: scrollProvider
      }, function (_ref) {
        var isDone = _ref.isDone,
          active = _ref.active;
        return !isDone && /*#__PURE__*/React.createElement(ContentLoading, {
          smaller: true
        });
      })));
    }
  }]);
}(React.Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "searchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "documents", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "documents"), _class2.prototype), _class2)) || _class;
var NoDocs = function NoDocs(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.noDocs
  }, children);
};
var DocumentItem = observer(function (_ref3) {
  var document = _ref3.document,
    hideTags = _ref3.hideTags,
    disabled = _ref3.disabled,
    onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement("a", {
    className: styles.item,
    onClick: disabled ? undefined : onClick,
    disabled: disabled,
    "data-test": 'document-item-' + document.title
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title,
    title: document.title
  }, truncate(document.title, {
    length: 40
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.description,
    title: document.description
  }, truncate(document.description, {
    length: 40
  }))), !hideTags && /*#__PURE__*/React.createElement(DocumentTagsStrip, {
    tags: document.tags
  }));
});
//# sourceMappingURL=index.js.map
